import * as changeTrackingDocument from "./changeTrackingDocument";
import { isPropertyDirty } from "./dirtyInfo";
import get from "lodash.get";
import flow from "lodash.flow";
import curry from "lodash.curry";

const traverse = curry((propertyPath, ruleObj, ctDocument) => {
  const result = Object.entries(ruleObj || {}).reduce((accumulator, [prop, fnOrObj]) => {
    const childPropertyPath = combinePath(propertyPath, prop);
    const match = typeof fnOrObj === "function" ? applyRule : traverse;
    const result = match(childPropertyPath, fnOrObj, accumulator);
    if (result.document.controlType === "BOOL" && !result.document.paramValue) result.document.paramValue = false;
    if (result.document.controlType === "AMOUNT" && !result.document.paramValue) result.document.paramValue = 0;
    return result;
  }, ctDocument);
  return result;
});

function applyRule(propertyPath, ruleFn, ctDocument) {
  if (isPropertyDirty(propertyPath, ctDocument.dirtyInfo)) {
    return ctDocument;
  }
  const newValue = ruleFn(ctDocument.document, ctDocument.originalDocument, get(ctDocument.document, propertyPath));
  return changeTrackingDocument.updateProperty(propertyPath, newValue, ctDocument);
}

function combinePath(left, right) {
  const combined = left ? `${left}.${right}` : right;
  return combined;
}

export function update(document, rules, changes = {}) {
  return flow(changeTrackingDocument.create, changeTrackingDocument.update(changes), traverse(null, rules))(document);
}
